var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-card"},[_c('div',[_c('b-img-lazy',_vm._b({attrs:{"src":_vm.image,"fluid":""}},'b-img-lazy',_vm.mainProps,false))],1),_c('div',{staticClass:"card-footer"},[_c('span',{},[_vm._v(_vm._s(_vm.card.type))])])])}
var staticRenderFns = []

export { render, staticRenderFns }